/**
 * Fix for Filament's searchable select component (Choices.js).
 *
 * Issue:
 * When using the searchable select dropdown, pressing the ArrowDown, ArrowUp,
 * ArrowRight, or ArrowLeft keys sometimes results in unintended text being inserted
 * into the search input, making it unusable.
 *
 * Cause:
 * Choices.js incorrectly captures key events when the dropdown is focused,
 * especially when the input is accessed via the Tab key.
 *
 * Temporary Fix:
 * - Prevent ArrowDown, ArrowUp, ArrowRight, and ArrowLeft keypresses from
 *   modifying the search input field.
 * - Allow normal dropdown navigation if the dropdown is open.
 *
 * Note:
 * This workaround is only needed **until Filament v4 is released**.
 * Once Filament v4 is out, this file should be **removed** to avoid conflicts.
 *
 * Related Filament Issues:
 * - https://github.com/filamentphp/filament/issues/11144
 * - https://github.com/filamentphp/filament/issues/10811
 *
 * TODO: [After launch] Remove this file once you upgrade to Filament v4!
 */
export function fixFilamentSearchable() {
	if (window.__filamentSearchableFixed) return;
	window.__filamentSearchableFixed = true;

	document.addEventListener('DOMContentLoaded', () => {
		const handleKeyDown = (event) => {
			const activeElement = document.activeElement;
			const choicesContainer = activeElement.closest('.choices');

			if (!choicesContainer) return; // Exit if not inside a Choices.js dropdown

			const isDropdownOpen = choicesContainer.classList.contains('is-open');
			const isSearchField = ['INPUT', 'DIV'].includes(activeElement.tagName);
			const isArrowKey = [
				'ArrowDown',
				'ArrowUp',
				'ArrowRight',
				'ArrowLeft',
			].includes(event.key);

			// Block arrow keys only when the input field is focused but allow navigation in the dropdown
			if (isSearchField && !isDropdownOpen && isArrowKey) {
				event.preventDefault();
				event.stopImmediatePropagation();
			}
		};

		document.addEventListener('keydown', handleKeyDown, true);
	});
}
